import { setLanguage, getLanguage } from "@/api/settings.api";

const state = {
  lang: getLanguage(),
  maxFileSize: 5000000
};

const getters = {};

const actions = {};

const mutations = {
  setSettingsLanguage(state, lang) {
    state.lang = lang;
    setLanguage(lang);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
